<h2 mat-dialog-title><mat-icon color="warn">warning</mat-icon> {{ data.title }}</h2>
<mat-dialog-content>
  <p>{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions>
    <button
      mat-raised-button
      [mat-dialog-close]="false"
      cdkFocusInitial
    >OK</button>
</mat-dialog-actions>
